import React from 'react';
import PropTypes from 'prop-types';
import { FaArrowLeft } from 'react-icons/fa';
import MembersGrid from '../MembersGrid';
import { Breadcrumbs } from '../../styled';
import { CountryDirectoryWrapper, BackButton } from './styled';

const CountryDirectory = React.forwardRef(
  ({ teamMembers, countryName, onMemberSelect, onClose }, ref) => {
    return (
      <CountryDirectoryWrapper
        ref={ref}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 40 }}
        transition={{ duration: 0.2 }}
      >
        <Breadcrumbs>
          <span onClick={onClose}>World</span> / <b>{countryName}</b>
        </Breadcrumbs>
        <MembersGrid
          teamMembers={teamMembers}
          onMemberSelect={onMemberSelect}
          isLoading={false}
          error={false}
        />
        <BackButton onClick={onClose}>
          <FaArrowLeft />
          Back
        </BackButton>
      </CountryDirectoryWrapper>
    );
  }
);

CountryDirectory.propTypes = {
  teamMembers: PropTypes.array.isRequired,
  onMemberSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  countryName: PropTypes.string.isRequired
};

export default CountryDirectory;
